export const isNullOrEmpty = (value) =>
  value === "" ||
  value === undefined ||
  value === " " ||
  value?.length === 0 ||
  value === null;

export const isArrayNullOrEmpty = (array) =>
  !array || array?.length === 0 || !Array.isArray(array);

export const containsValue = (arrayObject = [{}], key, value = "") =>
  arrayObject.some((obj) => obj[key] === value);

export const checkDetails = (array) => {
  let result = false;

  if (!isArrayNullOrEmpty(array)) {
    if (array?.some((x) => x?.purpose !== "All") && array.length < 2) {
      result = true;
    }
  }

  if (isArrayNullOrEmpty(array)) {
    result = true;
  }
  return result;
};

export const setMaxLength = (length, value) => {
  if (value?.length > length) {
    value = value.slice(0, length);
  }
  return value;
};

export const inputPattern = ({ pattern, length = 4, value }) => {
  // Remove non-numeric characters
  const numericValue = value.replace(pattern, "");
  // Limit the input to 4 characters
  const limitedValue = numericValue.slice(0, length);
  return limitedValue;
};

export const paymentTypes = {
  FIK: "FIK",
  IBAN: "IBAN",
  SWIFT: "BIC",
  REGNOACCOUNT: "REGNO/ACCOUNT",
  ABARoutingNumber: "ABA ROUTING NUMBER",
};

/** Map the stored bank type value to the user-facing label. */
export const displayBankType = (type) => (type === "BIC" ? "SWIFT" : type) || "";
